export const getBlockArraySchema = (blockArray: any, schema: any) => {
  if (schema?.is_required && schema.is_empty_as_null) {
    blockArray = blockArray.required()
  }
  return blockArray
}
